import axiosInstance from "app/axiosInstance";

interface UpdateStatusPayload {
  status: number;
  comment: string;
}

interface UpdateStatusOnlyPayload {
  status: number;
}

interface UpdateCommentOnlyPayload {
  comment: string;
}

class MileageDeviationsService {
  static getMileageDeviationsByQuery = async (data: any, accountId: string) => {
    return await axiosInstance.post(
      `/accounts/${accountId}/objects/search/calibration-deviations`,
      data
    );
  };

  static updateMileageDeviationStatus = async ({
    accountId,
    objectId,
    deviationId,
    data
  }: {
    accountId: string;
    objectId: string;
    deviationId: string;
    data: UpdateStatusPayload;
  }) => {
    return await axiosInstance.patch(
      `/accounts/${accountId}/objects/${objectId}/calibration-deviations/${deviationId}`,
      data
    );
  };

  static updateMileageDeviationStatusOnly = async ({
    accountId,
    objectId,
    deviationId,
    data
  }: {
    accountId: string;
    objectId: string;
    deviationId: string;
    data: UpdateStatusOnlyPayload;
  }) => {
    return await axiosInstance.patch(
      `/accounts/${accountId}/objects/${objectId}/calibration-deviations/${deviationId}`,
      data
    );
  };

  static updateMileageDeviationCommentOnly = async ({
    accountId,
    objectId,
    deviationId,
    data
  }: {
    accountId: string;
    objectId: string;
    deviationId: string;
    data: UpdateCommentOnlyPayload;
  }) => {
    return await axiosInstance.patch(
      `/accounts/${accountId}/objects/${objectId}/calibration-deviations/${deviationId}`,
      data
    );
  };
}

export default MileageDeviationsService;
